import apiTDO from '@/api/tdo';
import apiOption from '@/api/option';

const defaultState = () => ({
	listTDO: [],
	detailTDO: {},
	tdoPagination: '',
	optionTOforTDO: [],
	TDOforreceive: [],
	response: {
		code: '',
		message: ''
	},
	TDOStatus: [],
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
	productTDO(state){
		if (state.detailTDO) {
			return state.detailTDO.tdo_detail.map((el) => {
				return {
					product_id: el.tdo_detail_product_id,
					quantity: el.tdo_detail_quantity_received
				}
			})
		}
	}
};

const mutations = {
	setTDO(state, data) {
		state.listTDO = data.data
		state.tdoPagination = data.pagination;
	},
	setDetailTDO(state, data) {
		state.detailTDO = data
	},
	setTDOStatus(state, data) {
		state.TDOStatus = data
	},
	setOptionTOforTDO(state, data) {
		state.optionTOforTDO = data
	},
	setOptionTDOforreceive(state, data) {
		state.TDOforreceive = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataTDO(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getTDO({ commit, dispatch }, params) {
		apiTDO.getTDO(params).then(({ data: { data } }) => {
			commit('setTDO', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setTDO', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailTDO', {});
		});
	},
	getDetailTDO({ commit, dispatch }, params) {
		apiTDO.getDetailTDO(params).then(({ data: { data } }) => {
			commit('setDetailTDO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailTDO', {});
		});
	},
	getTDOIn({ commit, dispatch }, params) {
		return new Promise((resolve) => {
			apiTDO.getTDOIn(params).then(({ data: { data } }) => {
				commit('setTDO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setTDO', { data: [], pagination: {} });
				const data = err.response.data
				dispatch("errorHandler", data)
				commit('setDetailTDO', {});
			});
		});
	},
	getTDOOut({ commit, dispatch }, params) {
		apiTDO.getTDOOut(params).then(({ data: { data } }) => {
			commit('setTDO', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setTDO', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailTDO', {});
		});
	},
	getTDOStatus({ commit }, params) {
		return new Promise((resolve) => {
			apiTDO.getTDOStatus(params).then(({ data: { data } }) => {
				commit('setTDOStatus', data.results);
				resolve()
			}).catch(() => {
				commit('setTDOStatus', []);
			});
		});
	},
	getOptionTOforTDO({ commit, dispatch }) {
		apiOption.getOptionTOforTDO().then(({ data: { data } }) => {
			commit('setOptionTOforTDO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setOptionTOforTDO', []);
		});
	},
	getOptionTDOforReceive({ commit, dispatch }) {
		apiOption.getOptionTDOforReceive().then(({ data: { data } }) => {
			commit('setOptionTDOforreceive', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setOptionTDOforreceive', []);
		});
	},
	async exportTDO({ commit, dispatch }){
		await dispatch('isAttempting', null, { root: true })
		await apiTDO.exportTDO().then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data pengiriman transfer'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportTDOIN({ commit, dispatch }){
		await dispatch('isAttempting', null, { root: true })
		await apiTDO.exportTDOIN().then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data pengiriman transfer'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportTDOOUT({ commit, dispatch }){
		await dispatch('isAttempting', null, { root: true })
		await apiTDO.exportTDOOUT().then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data pengiriman transfer'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createTDO({ commit, dispatch }, params) {
		await apiTDO.createTDO(params).then(res => {
			const data = res.data;
			dispatch('success', data)
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal proses pengiriman barang'
			}, { root: true });
		});
	},
	async receiveTDO({ commit, dispatch }, params) {
		await apiTDO.receiveTDO(params).then(res => {
			const data = res.data;
			dispatch('success', data)
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal proses penerimaan barang'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit("saveResponse", data);
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};